import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { LoadingBars } from '@components/LoadingBars/LoadingBars';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { Header, Modal } from '@components/main-components/modals/Modal';
import { ModalContext } from '@context/modal';
import { etherscanForTransaction } from '@utils/helpers';

export const ProcessingModal = ({
  heading,
  txHash,
  chainId,
}: {
  heading: string;
  txHash: string;
  chainId: number;
}) => {
  const { closeCancelModal } = ModalContext.useContainer();

  const body = (
    <>
      <ImageContainer>
        <LoadingBars height={undefined} />
      </ImageContainer>
      <Header css={{ justifyContent: 'center', marginTop: 8, '@tablet': { marginTop: 16 } }}>
        Processing...
      </Header>
      <TextContent>
        <Text>
          {heading}
          <div>
            View its progress on{' '}
            <AccessibleLink
              absoluteUri={etherscanForTransaction({ transactionHash: txHash, chainId })}
              type="external"
            >
              Etherscan
            </AccessibleLink>
          </div>
        </Text>
      </TextContent>
    </>
  );

  return (
    <Modal
      body={body}
      closeModal={closeCancelModal}
      headerStyles={{ height: 0 }}
      bodyStyles={{ marginTop: 0 }}
    />
  );
};

const ImageContainer = styled('div', {
  width: '100%',
  marginBottom: 8,
  display: 'flex',
  justifyContent: 'center',
});

const TextContent = styled('div', {
  textAlign: 'center',
  fontSize: 14,
  marginTop: 8,
  '@tablet': {
    fontSize: 16,
    marginTop: 16,
  },
});

const Text = styled('div', {
  color: '$neutral700',
  lineHeight: '20px',
  fontWeight: 400,
  a: {
    fontWeight: 500,
  },
});
